// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MNLBOEmsHvXMTBNBriCc {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 4vw;
  right: 4vw;
  width: 3.75rem;
  height: 3.75rem;
  border-radius: 2.5rem;
  z-index: 100;
  background: var(--white);
  border: 0.125rem solid var(--midnight-purple);
  cursor: pointer;
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .MNLBOEmsHvXMTBNBriCc {
    bottom: 12vw;
  }
}

@media only screen and
  (max-width: 639px) {
  .MNLBOEmsHvXMTBNBriCc {
    width: 2.5rem;
    height: 2.5rem;
    bottom: 15vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ScrollUpButton/ScrollUpButton.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,UAAU;EACV,cAAW;EACX,eAAY;EACZ,qBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,6CAAwC;EACxC,eAAe;AACjB;;AAEA;;;EACE;IACE,YAAY;EACd;AACF;;AAEA;;EACE;IACE,aAAW;IACX,cAAY;IACZ,YAAY;EACd;AACF","sourcesContent":[".scrollUpButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  bottom: 4vw;\n  right: 4vw;\n  width: 60px;\n  height: 60px;\n  border-radius: 40px;\n  z-index: 100;\n  background: var(--white);\n  border: 2px solid var(--midnight-purple);\n  cursor: pointer;\n}\n\n@media (--desktop-small) {\n  .scrollUpButton {\n    bottom: 12vw;\n  }\n}\n\n@media (--mobile) {\n  .scrollUpButton {\n    width: 40px;\n    height: 40px;\n    bottom: 15vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollUpButton": `MNLBOEmsHvXMTBNBriCc`
};
export default ___CSS_LOADER_EXPORT___;
